/**
 * @author wql
 * @description 学员评语审核页面
 * @Date 2021/1/18
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool,utils_tool} from '@/tool';
import 'antd/dist/antd.css';


let {checkStrLength, Session} = utils_tool;
let {WizContainer, modelUtils} = framework_tool;
let {WizRow,WizCol,WizLayout,WizSpin,WizTypography,WizCard,WizInput,WizButton,WizModal,WizCollapse,WizTable} = component_tool;
const { Header, Content } = WizLayout;
const { Title } = WizTypography
import '@/styles/components/question/questionPreview/index.less'
import moment from "moment";
import classnames from "classnames";
import { QsInput } from '@/components/questionnaire/components/components';


const Comp = (props) => {
  const { CompName, index, pathCommentDetailedName,answer,id,key } = props
  const otherProps = {
    index,key,
    id: id,
    title: pathCommentDetailedName,
    answer: answer,
    options: [],
    otherAnswer: '',
    img: -1,
    type: 5,
  };
  return (
    <div className={classnames("qs-item","normal")}>
      <div className="qs-item-title">
        <strong>{index + 1}、{ pathCommentDetailedName }</strong>
      </div>
      <div className="qs-item-content">
        <div className="answer"><CompName { ...otherProps } /></div>
      </div>
    </div>
  )
}


const StageComment = (props) =>{
  const {data,openModel} = props
  let dataView = [];
  let i = 1;
  data && data.length && data.forEach(element => {
    let stageOrder = '关联路径阶段'+i+++'：';
    let name = element.trainPathName+'-'+element.trainPathStageName
    let showMore = '查看详情';
    let view =   <WizRow style={{margin:'10px 0px'}}>
                    <WizCol >{stageOrder}{name}
                    <WizButton type="link" onClick={e => openModel(element)}>{showMore}</WizButton>
                    </WizCol>
                </WizRow>
    dataView.push(view);
  });
  if(dataView.length){
    return <div style={{margin:'20px 0px'}}>{dataView}</div> ;
  }else{
    return dataView
  }
  
}

const getTrainPathComment = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/comment/auditComment') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('auditCommentInfo', record)
      } else {
        record = Session.get('auditCommentInfo') || 0
      }
    }
  } else {
    record = Session.get('auditCommentInfo') || 0
  }
  return record
}


class AuditComment extends WizContainer {
  componentName = "auditComment";

  constructor(props) {
    super(props)
    let record = getTrainPathComment(props.history);
    this.state = {
      recordNew:null,
      timestamp: new Date().getTime(),
      remarks:'',
      stageCommentInfo:{},
      modelName:'',
      visible:false,
      getStudentInfo:[],
      proportion:''
    }
    this.studentCommentOld= record;
  }

  _componentWillMount() {
    let record = getTrainPathComment(this.props.history);
    if (record && record.id) {
      this.getStudentCommentDetail(record.id);
    }
    if (record && record.pathCommentId) {
      this.getStageInfo(record.pathCommentId);
    }
    
  }

  propsAndStateOnChange = {
    studentCommentDetail: this._getStudentCommentDetail.bind(this),
    batchUpdate: this._batchUpdate.bind(this),
    getStageInfo: this._getStageInfo.bind(this),
    getStudentPathInfo: this._getStudentPathInfo.bind(this)
  };

  /**
   * 获取返回数据
   * @param nextProps
   * @param nextState
   * @private
   */
  _getStudentCommentDetail(nextProps, nextState) {
    if (nextProps.studentCommentDetail.code === 1) {
      this.setState({
        recordNew:nextProps.studentCommentDetail.data,
      });
    } else {
      wizNotice.error(nextProps.studentCommentDetail.msg);
    }
    return true;
  }

  _getStageInfo(nextProps, nextState) {
    if (nextProps.getStageInfo.code === 1) {
      this.setState({
        stageCommentInfo:nextProps.getStageInfo,
      });
    } else {
      wizNotice.error(nextProps.getStageInfo.msg);
    }
    return true;
  }

  _batchUpdate(nextProps, nextState) {
    if (nextProps.batchUpdate.code === 1) {
      wizNotice.success("操作成功");
      let record = this.studentCommentOld;
      record.id = record.pathCommentId
      this.jumpPage('replace', '/comment/trainPathCommentAudit',record);

      // this.props.changeModal(false, true);
      // this.onChange(this.initTargetKeys, this.initTargetRows);
    } else {
      wizNotice.error(nextProps.batchUpdate.msg);
    }
  }

  /**
   * 获取 评语关联阶段详情
   * @param values
   * @private
   */
   getStageInfo(id) {
    let apiPath = "trainPathTask/getTrainPathCommentStageInfo";
    let payloadKey = "trainPathTask@getTrainPathCommentStageInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          entityId: id,
          type:5
        }
      }
    });
  }

  /**
   * 获取 学员路径评语明细信息
   * @param values
   * @private
   */
  getStudentCommentDetail(id) {
    let apiPath = "studentCommentManagement/selectOneById";
    let payloadKey = "studentCommentManagement@studentCommentDetail";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          id: id,
        }
      }
    });
  }

  _getStudentPathInfo(nextProps, nextState) {
    let o = nextProps.getStudentPathInfo;
    if (o['success']) {
      let data = o.data;
      nextState.getStudentInfo = o.data
      return true;
    }

    wizNotice.error(o['msg'])
    return false;
  }

  _renderHead(){
    const {recordNew} = this.state
    return(
      <div className="question-header">
        <WizRow className='question-header-title' type='flex' justify='center' align='middle'>
          <WizCol span={20}>
            <Title className='header-title' level={4}>{recordNew && recordNew.pathCommentName}</Title>
          </WizCol>
        </WizRow>
        <WizRow type='flex' justify={'end'} align='middle'>
          <WizCol>
            <div><span>提交人：{recordNew && recordNew.submiterFullName }({recordNew && recordNew.submiterUserName})</span><span style={{ margin: '0 20px 0 45px' }}>提交时间：{recordNew && moment(recordNew.submitTime).format('YYYY-MM-DD HH:mm')}</span></div>
          </WizCol>
        </WizRow>
      </div>
    )
  }

  _renderContent(){
    const {recordNew} = this.state
    if (recordNew && recordNew.detailInfoList && recordNew.detailInfoList instanceof Array && recordNew.detailInfoList.length>0){
      const Comps =recordNew.detailInfoList.map((val, index) => {
        const otherProps = {
          key: val.id,
          index,
          ...val
        }
        let comp = <Comp CompName = { QsInput } { ...otherProps } /> //填空题 //单行文本题
        return comp;
      })
      return(
        <div className="question-content">
          {Comps}
        </div>
      )
    }else {
      return (<div className="question-content"></div>);
    }
  }

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  getStudentPathInfo(){
    let columns = [
      { title: '任务名称',
        dataIndex: 'name',
        width:'150px',
        key: 'name'},
      { title: '任务类型',
        dataIndex: 'type',
        width:'100px',
        key: 'type'},
      { title: '任务内容',
        dataIndex: 'entityName',
        width:'200px',
        key: 'entityName'},
      { title: '状态',
        dataIndex: 'taskPassState',
        width:'100px',
        key: 'taskPassState'},
      { title: '完成时间',
        dataIndex: 'taskPassTime',
        width:'180px',
        key: 'taskPassTime'},
    ]
    let pathList = this.state.getStudentInfo;
    let data = [];
    if (pathList.length>0){
      pathList.forEach(info =>{
        if(info.state = 1){
          info.state = '草稿'
        }else if(info.state = 2){
          info.state = '已发布'
        }else if(info.state = 3){
          info.state = '已关闭'
        }else if(info.state = 4){
          info.state = '建设中'
        }

        info.taskList.forEach(val =>{
          if (val.type == 1){
            val.type = '在线课程'
          }else if(val.type == 2){
            val.type = '在线考试'
          }else if(val.type == 3){
            val.type = '培训管理'
          }else if(val.type == 4){
            val.type = '能力认证'
          }else if(val.type == 5){
            val.type = '在线评语'
          }else if (val.type == 6) {
            val.type = '课程组'
          }else if(val.type == 7) {
            val.type = '资讯'
          }else if(val.type == 8) {
            val.type = '作业'
          }

          if (val.taskPassState == 1){
            val.taskPassState = '通过';
          }else if (val.taskPassState == 0){
            val.taskPassState = '未通过';
          }
        })
        this.setState({
          proportion : '(' + info.proportion + ')'
        })

        let header = info.name + '(' + info.proportion + ')'
        data.push(
          <WizTable dataSource={info.taskList} columns={columns} />
        )
      })
      return data
    }else{
      return null
    }
  };

  openModel(record){
    this.doActions([
      {
        path: 'trainPathStage/getCommentStudentPathInfo',
        payload: {
          key: 'getStudentPathInfo',
          apiParams: {
            id: record.trainPathId,
            stageId : record.trainPathStageId,
            personId:this.state.recordNew.personId
          }
        }
      },
    ]);
    this.setState({
      modelName: record.trainPathName + '-' + record.trainPathStageName,
      visible: true,
    });
  }

  _renderStageCommentInfo(){
    const {stageCommentInfo} = this.state
    return(
      <StageComment {...stageCommentInfo} openModel={(record)=>this.openModel(record)}/>
    )
  }

  _remarksChange =  ({ target: { value } })  => {
    this.state.remarks = value;
  };


  /**
   * modal框的确定按钮触发 通过
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = () => {
    this._auditSubmit(2);
  };

  /**
   * modal框的确定按钮触发 驳回
   * 可以在里面增加关闭modal前的操作及校验
   */
  _refuse = () => {
    this._auditSubmit(3);
  };

  /**
   * 提交审核 2 通过；3 驳回
   * @param state
   * @private
   */
  _auditSubmit(state){
    let apiPath = "studentCommentManagement/updateState";
    let payloadKey = "studentComment@batchAudit";
    let remarks = this.state.remarks;
    let ids = [];
    ids.push(this.studentCommentOld.id);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          state:state,
          ids: ids,
          auditReason:remarks
        }
      }
    });
  }

  _render() {
    return <>
      <WizCard title={'路径评语'}>
        <WizLayout className="full-layout question-preview">
          <Header>
            {this._renderHead()}
          </Header>
          <Content>
            {this._renderContent()}
          </Content>
        </WizLayout>
      </WizCard>

      <WizCard title={'评语审批'}>
        {this._renderStageCommentInfo()}
        <WizInput.TextArea maxLength={300} rows={5} placeholder='请录入审核意见' onChange={this._remarksChange}/>
        <WizRow className="form-btns row-item">
          <WizCol span={1}>
            <WizButton title='通过' type="primary" onClick={this._ok}>通过</WizButton>
          </WizCol>
          <WizCol span={1}>
          </WizCol>
          <WizCol span={1}>
            <WizButton title='驳回' type="danger" onClick={this._refuse}>驳回</WizButton>
          </WizCol>
        </WizRow>
      </WizCard>

      <WizModal key={2} title={this.state.modelName+this.state.proportion} visible={this.state.visible} onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)} width={800}>
             {this.getStudentPathInfo()}
      </WizModal>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {studentCommentManagement ,trainPathTask,trainPathStage} = state;
  const studentCommentDetail = modelUtils.getModelEntity(studentCommentManagement, 'studentCommentManagement@studentCommentDetail');
  const batchUpdate = modelUtils.getModelEntity(studentCommentManagement, 'studentComment@batchAudit');
  const getStageInfo = modelUtils.getModelEntity(trainPathTask, 'trainPathTask@getTrainPathCommentStageInfo');
  const getStudentPathInfo = modelUtils.getModelEntity(trainPathStage, "getStudentPathInfo");
  const load = modelUtils.getLoadingState(state, ['studentCommentManagement']);
  return {
    studentCommentDetail: studentCommentDetail,
    batchUpdate: batchUpdate,
    getStageInfo,
    getStudentPathInfo,
    load
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(AuditComment);
